export interface IRoute {
  id: string;
  name: string;
  path: string;
  renderType?: RenderType;
  screenId?: string;
  isIndex: boolean;
  isGuestRoute?: boolean;
  isProtected?: boolean;
  createdAt: string;
  updatedAt: string;
}

export enum RenderType {
  SCREEN = 'SCREEN',
  DYNAMIC_SINGLE_VIEW = 'DYNAMIC_SINGLE_VIEW',
}
